import { render } from "./DescriptionTextComponent.vue?vue&type=template&id=2fdfd4f1"
import script from "./DescriptionTextComponent.vue?vue&type=script&lang=js"
export * from "./DescriptionTextComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__